import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'antd';
import { PageHeader as AntPageHeader } from '@ant-design/pro-layout';
import Loading from 'components/Loading';

import './page.less';
import Content from 'components/Layout/Content';

const Page = ({ children, className, forwardRef, loading, full, ...rest }) => (
  <Content ref={forwardRef} className={`page ${full ? 'page--full' : ''} ${className || ''}`} {...rest}>
    {loading ? <Loading /> : children}
  </Content>
);

const PageContent = ({ children, className, forwardRef, ...rest }) => (
  <Card ref={forwardRef} className={`page-content ${className || ''}`} {...rest}>
    {children}
  </Card>
);

const PageHeader = ({
  className,
  breadcrumb = {},
  ...rest
}) => (
  <AntPageHeader
    {...rest}
    breadcrumb={{
      itemRender: (route, params, routes) => (
        routes.indexOf(route) === routes.length - 1
          ? route.breadcrumbName
          : <Link to={route.path}>{route.breadcrumbName}</Link>
      ),
      ...breadcrumb,
    }}
    className={`page-header ${className || ''}`}
  />
);

const PageFooter = ({
  sticky,
  children,
}) => (
  <div className={`page-footer ${sticky ? 'page-footer--sticky' : ''}`}>
    {children}
  </div>
);

Page.Header = PageHeader;
Page.Content = PageContent;
Page.Footer = PageFooter;

export default Page;
